/**
 * Authenticated auction-group hub. The public marketing page lives at `/`.
 * @type {string}
 */
export const APP_HOME = '/home';

/**
 * Same-origin relative path for post-login navigation.
 * `/` maps to the hub so signed-in users are not dumped on the marketing page.
 * @param {string|null|undefined} raw
 * @returns {string}
 */
export function sanitizeReturnUrl(raw) {
  if (!raw || typeof raw !== 'string') return APP_HOME;
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.includes('://')) return APP_HOME;
  if (raw === '/') return APP_HOME;
  return raw;
}
